/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var People1MinusIcon24Regular = forwardRef('People1MinusIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 1a6 6 0 1 0 0 12 6 6 0 0 0 0-12ZM7.5 7a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0Z" }),
        React.createElement("path", { d: "M4.591 18.13c-.505.684-.841 1.603-.841 2.87a.75.75 0 0 1-1.5 0c0-1.551.418-2.791 1.135-3.762.712-.962 1.68-1.608 2.707-2.043 2.03-.859 4.413-.945 5.908-.945a.75.75 0 0 1 0 1.5c-1.48 0-3.596.095-5.323.827-.852.36-1.575.862-2.086 1.553Z" }),
        React.createElement("path", { d: "M13.25 19a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5h-8a.75.75 0 0 1-.75-.75Z" })));
});
